export function MobileNavigation() {
    // Prevent showing animation on window resize
    let resizeDelay;
    window.addEventListener('resize', () => {
        document.body.classList.add('resize-animation-stopper');
        isMobile();
        clearTimeout(resizeDelay);
        resizeDelay = setTimeout(() => {
            document.body.classList.remove('resize-animation-stopper');
        });
    });

    function isMobile() {
        if (window.matchMedia('(max-width: 1400px)').matches) {
            document.body.classList.add('mobile-view');
            return true;
        } else {
            document.body.classList.remove('mobile-view');
            return false;
        }
    }
    isMobile();
    // Menu toogle on mobile
    const menuContainer = document.querySelector('.nav');
    if (menuContainer) {
        const navToggle = menuContainer.querySelector('.nav-toggle');
        const menuToggle = menuContainer.querySelector('.menu-toggle');

        if (navToggle && menuToggle) {
            navToggle.addEventListener('click', function (e) {
                this.classList.toggle('open');
                menuToggle.classList.toggle('active');
                e.stopPropagation();
            });
            // Submenu toogle on mobile
            menuContainer.querySelectorAll('.navListItem--sub a > span').forEach(el => {
                el.addEventListener('click', function (event) {
                    if (isMobile()) {
                        event.preventDefault();
                        event.stopPropagation();
                        const allMenuItems = menuContainer.querySelectorAll('.collapsable-link');
                        for (let i = 0; i < allMenuItems.length; i++) {
                            const clickedElement = event.target as Element;
                            const parsedElem = allMenuItems[i];
                            const parent = parsedElem.parentNode as Element;
                            if (clickedElement.parentNode !== parsedElem) {
                                if (parsedElem.nextElementSibling && parent) {
                                    const nestedLink = clickedElement.closest('.nav-overlay') as Element;
                                    if (nestedLink && nestedLink.classList.contains('show')) {
                                        const subMenuItems = menuContainer.querySelectorAll('.navList__item--sub');
                                        for (let s = 0; s < subMenuItems.length; s++) {
                                            const subMenuItem = subMenuItems[s];
                                            subMenuItem.classList.remove('active');
                                            const list  = subMenuItem.querySelector('.nav-overlay__submenu');
                                            if (list) {
                                                list.classList.remove('show');
                                            }
                                        }
                                        this.parentNode.nextElementSibling.classList.toggle('show');
                                        this.parentNode.parentNode.classList.toggle('active');
                                        return;
                                    } else {
                                        parsedElem.nextElementSibling.classList.remove('show');
                                        parent.classList.remove('active');
                                    }
                                }
                            }
                        }
                        this.parentNode.nextElementSibling.classList.toggle('show');
                        this.parentNode.parentNode.classList.toggle('active');
                    }
                });
            });
        }
    }
}
